import { Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { StateService } from '@uirouter/core';
import { ReplaySubject } from 'rxjs';
import { take } from 'rxjs/operators';
import { LoggingService } from '../../shared/services/logging';
import { HasValidTokens, RevokeAccess } from '../store/quickbooks.actions';

@Component({
    selector: 'ef-quickbooks-revoke-access',
    templateUrl: './quickbooks-revoke-access.component.html',
    styleUrls: ['./quickbooks-revoke-access.component.scss'],
    standalone: false
})
export class QuickbooksRevokeAccessComponent implements OnInit {
    RevokeAccessSubject = new ReplaySubject<void>(1);
    constructor(
        private log: LoggingService,
        private store: Store,
        private ss: StateService
    ) {}

    ngOnInit(): void {
        this.RevokeAccessSubject.pipe(take(1)).subscribe(() => {
            this.store.dispatch(new RevokeAccess());
            this.store.dispatch(new HasValidTokens(false));
            this.ss.go('main');
        });
    }
}
